// extracted by mini-css-extract-plugin
module.exports = {"container":"reviewCarousel_container__XlGf1","slide":"reviewCarousel_slide__V_YfS","thumbnail":"reviewCarousel_thumbnail__hZDT5","lightbox":"reviewCarousel_lightbox__xo2w8"};